import {
    backgroundColorModal,
    backgroundColorNormal,
    borderColorDisabled,
    ColorBlueDark,
    ColorGrey6,
    ColorWhite,
} from './palette';

export const basketButtonBg = backgroundColorNormal;
export const basketButtonBgHover = ColorBlueDark;
export const basketButtonText = ColorWhite;

export const basketModuleBg = backgroundColorModal;

export const basketItemBg = ColorGrey6;
export const basketItemBorder = borderColorDisabled;
